import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutWarningsAndExceptionsTable extends Layout {
    tableWarningsAndExceptions: Table;
}
